import { Injectable } from '@angular/core';
import * as moment from 'moment';
import 'moment-timezone';
@Injectable({
  providedIn: 'root'
})

export class UserLocalizationService{
   
  getLocalTimeZone():string{
    return moment.tz.guess();
  }
  getUserTime():string{
    return moment().format('YYYY-MM-DD HH:mm:ss');
  }
  getUserTimeZoneCode():string{
    return moment().tz(this.getLocalTimeZone()).format('z');
  }

  getFormattedDateTimeAsInt(date: Date): number {
    const formattedDate = moment(date).format('MMDDHHmmss');
    return parseInt(formattedDate, 10);
  }
  
  formatToAmPm(value: string): string {
    if (!value) return '';

    const dateOnlyRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateOnlyRegex.test(value)) {
      const [y, m, d] = value.split('-').map((x) => Number.parseInt(x, 10));
      const yyyy = String(y).padStart(4, '0');
      const mm = String(m).padStart(2, '0');
      const dd = String(d).padStart(2, '0');
      const midnightLocal = new Date(y, m - 1, d, 0, 0, 0);
      const time = midnightLocal.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });
      return `${yyyy}-${mm}-${dd} ${time}`;
    }

    const midnightUtcRegex = /^(\d{4}-\d{2}-\d{2})T00:00:00(\.\d+)?Z$/;
    const midnightUtcMatch = value.match(midnightUtcRegex);
    if (midnightUtcMatch) {
      const [y, m, d] = midnightUtcMatch[1].split('-').map((x) => Number.parseInt(x, 10));
      const yyyy = String(y).padStart(4, '0');
      const mm = String(m).padStart(2, '0');
      const dd = String(d).padStart(2, '0');
      const midnightLocal = new Date(y, m - 1, d, 0, 0, 0);
      const time = midnightLocal.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });
      return `${yyyy}-${mm}-${dd} ${time}`;
    }

    const date = new Date(value);
    if (isNaN(date.getTime())) return value;

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const dd = String(date.getDate()).padStart(2, '0');

    const time = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });

    return `${yyyy}-${mm}-${dd} ${time}`;
  }
}